import React, { useRef } from "react";
import "./tab.scss";

interface Props {
  activeTab: string;
  singleTabWidth?: string;
  tabData: {
    id: string;
    label: string | React.ReactNode;
  }[];
  onChange?: (tabId: string) => void;
}

const Tab = ({
  activeTab,
  tabData,
  onChange = () => {},
  singleTabWidth,
}: Props) => {
  const tabRef = useRef<HTMLDivElement>(null);

  return (
    <div className="commonTabUi_container">
      {tabData?.map((tab) => (
        <>
          <div
            key={tab?.id}
            className={`commonTabUi_cta ${activeTab == tab?.id ? "active" : ""}`}
            style={{
              width: singleTabWidth || "auto",
            }}
            onClick={() => onChange(tab?.id)}
            ref={activeTab == tab?.id ? tabRef : null}
          >
            {tab?.label || ""}
          </div>
        </>
      ))}
    </div>
  );
};

export default Tab;
